var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "radar-control", attrs: { id: "radar-control" } },
    [
      _c("v-select", {
        attrs: { items: _vm.radar_angle_sliders, variant: "outlined" },
        model: {
          value: _vm.radar_angle_selected,
          callback: function($$v) {
            _vm.radar_angle_selected = $$v
          },
          expression: "radar_angle_selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }